module.exports = __webpack_public_path__ + "img/servo.e1da444b.jpg";